import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Utils } from '../../utils';
import './signup.css';
import logo from '../../assets/notifysphere-logo.png';
import eyeOpenImg from '../../assets/icons/eye.png';
import eyeCloseImg from '../../assets/icons/invisible.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setError('Invalid reset link. Please use the link from your email.');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!token) return;
        if (newPassword.length < 6) {
            setError('New password must be at least 6 characters');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(Utils.baseurl + 'reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword })
            });
            const result = await response.json();

            if (result.status) {
                setSuccess(result.message || 'Password reset successfully. Redirecting to login...');
                setTimeout(() => navigate('/signIn'), 2000);
            } else {
                setError(result.message || 'Invalid or expired link. Please request a new reset link.');
            }
        } catch (err) {
            setError('Connection error. Please try again.');
        }
        setLoading(false);
    };

    const invalidLinkBlock = (
        <div className="signup_page">
            <div className="signup_page_inner">
                <div className="page_logo">
                    <a href="/">
                        <img src={logo} alt="notifySphere" />
                    </a>
                </div>
                <div className="form_outer">
                    <div className="text-center">
                        <div className="form_heading">
                            <h1>Invalid link</h1>
                            <p style={{ color: 'black' }}>Invalid reset link. Please use the link from your email or request a new one.</p>
                        </div>
                    </div>
                    <div className="login_form">
                        <div className="signup_button">
                            <Link to="/forgot-password" style={{ textDecoration: 'none', width: '100%' }}>
                                <button type="button">
                                    Request reset link
                                </button>
                            </Link>
                        </div>
                        <div className="already_acc">
                            <span color="dark">
                                <Link to="/signIn">Back to Sign in</Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    if (!token) {
        return invalidLinkBlock;
    }

    return (
        <div className="signup_page">
            <div className="signup_page_inner">
                <div className="page_logo">
                    <a href="/">
                        <img src={logo} alt="notifySphere" />
                    </a>
                </div>
                <div className="form_outer">
                    <div className="text-center">
                        <div className="form_heading">
                            <h1>Set new password</h1>
                            <p style={{ color: 'black' }}>Enter your new password below.</p>
                        </div>
                    </div>

                    {error && (
                        <div className="alert alert-danger">
                            <span>{error}</span>
                        </div>
                    )}
                    {success && (
                        <div className="alert alert-success">
                            <span>{success}</span>
                        </div>
                    )}

                    <div className="login_form">
                        <form onSubmit={handleSubmit}>
                            <div className="input_boxes">
                                <div className="password_box">
                                    <label htmlFor="reset_new_password">New password (min 6 characters)</label>
                                    <div className="email_input password_input">
                                        <input
                                            id="reset_new_password"
                                            type={showNewPassword ? 'text' : 'password'}
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                            minLength={6}
                                        />
                                        <img
                                            src={showNewPassword ? eyeCloseImg : eyeOpenImg}
                                            alt="Toggle"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                        />
                                    </div>
                                </div>
                                <div className="password_box">
                                    <label htmlFor="reset_confirm_password">Confirm new password</label>
                                    <div className="email_input password_input">
                                        <input
                                            id="reset_confirm_password"
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                            minLength={6}
                                        />
                                        <img
                                            src={showConfirmPassword ? eyeCloseImg : eyeOpenImg}
                                            alt="Toggle"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="signup_button">
                                <button
                                    style={{ backgroundColor: loading ? '#686abd' : 'rgb(67, 70, 206)' }}
                                    disabled={loading}
                                    type="submit"
                                >
                                    {loading ? <FontAwesomeIcon icon={faSpinner} spin size="1x" /> : <span>Reset password</span>}
                                </button>
                            </div>
                            <div className="already_acc">
                                <span color="dark">
                                    <Link to="/signIn">Back to Sign in</Link>
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
